import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import Logger from '@medflex/utils/Logger';
import SettingsBox from '@medflex/components/stories/SettingsBox';
import Button from '@medflex/components/stories/Button';
import { gdtConstants, gdtHelpers } from '@medflex/gdt';

const { GdtFeatures } = gdtConstants;

const PathSettingsBox = ({ feature, setValues, children }) => {
  const [isEdit, setIsEdit] = useState(false);
  const { t } = useTranslation('physician', { keyPrefix: 'PVSIntegrationModule' });

  const featureFunctions = gdtHelpers[feature];

  const {
    register,
    handleSubmit: wrapSubmit,
    errors,
    formState: { isValid },
  } = useForm({
    mode: 'onChange',
  });

  const handleSubmit = useCallback(
    values => {
      try {
        setValues(values);
      } catch (e) {
        Logger.error(e);
      }

      setIsEdit(false);
    },
    [setValues],
  );

  if (!featureFunctions) {
    return null;
  }

  return (
    <SettingsBox title={t(`${feature}.title`)} canEdit={!isEdit} onEdit={() => setIsEdit(true)}>
      {isEdit ? (
        <form onSubmit={wrapSubmit(handleSubmit)} className="flex flex-col">
          {children({ register, isEdit, errors })}
          <div className="flex space-x-8 items-center justify-end">
            <Button kind="link" onClick={() => setIsEdit(false)}>
              {t(`${feature}.abort`)}
            </Button>
            <Button isDisabled={!isValid} type="submit">
              {t(`${feature}.submit`)}
            </Button>
          </div>
        </form>
      ) : (
        children({ isEdit })
      )}
    </SettingsBox>
  );
};

PathSettingsBox.propTypes = {
  feature: PropTypes.oneOf([
    GdtFeatures.SYNC_PATIENTS,
    GdtFeatures.OPEN_PATIENT_IN_PVS,
    GdtFeatures.OPEN_PATIENT_IN_MEDFLEX,
    GdtFeatures.WRITE_EXAMINATION,
  ]).isRequired,
  setValues: PropTypes.func.isRequired,
  children: PropTypes.func.isRequired,
};

export default PathSettingsBox;
